export interface ITimezone {
  id: string;
  name: string;
  offset: {
    minutes?: number;
    hours?: number;
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deserializeTimezone(data: { [key: string]: any }): ITimezone {
  return {
    id: data.ID,
    name: data.name,
    offset: {
      minutes: data.offset?.minutes,
      hours: data.offset?.hours,
    },
  };
}
